import styled from "styled-components"

interface IWrapper {
  minwidth?: string;
}

export const Wrapper = styled.div<IWrapper>`
  min-width: ${({ minwidth }) => minwidth ? minwidth : '200px'};

  .searchTipo {
    background: ${({ theme }) => theme.colors.surface.surface} !important;  
    margin: 0  !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline} !important;
    border-radius: 0 !important;

    i {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      font-size: 13px !important;
    }

    input {
      background: ${({ theme }) => theme.colors.surface.surface} !important;
    }
  }

  .tipoOption {
    height: 52px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    user-select: none;
    cursor: pointer;

    .description {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-left: 6px;
    }

    &:hover {
      background: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }

    .checkbox {
      pointer-events: none;
    }
  }

  .hide {
    display: none !important;
  }
`;
